import React from 'react';

const Step = (props) => {
    if(props.currentStep === props.step){
        return props.children
    }
    else{
        return null;
    }
};

export default React.memo(Step);